
<!--start header-->
<header >
  
<!--start header-caption--> 
    <div class="header-caption">
        <div class="container">
            <div class="row d-flex justify-between">

                <div class="col-lg-4 col-md-6  p-2">
                    <i class="far fa-clock pr-1 "></i>
                    <span>Opening Hours: Mon - Sat 8.00 - 18.00</span>
                </div>

                <div class="col-lg-4 col-md-6 p-2">
                    
                    <span class="pr-2">Follow Us:</span>
                    <i class="fab fa-facebook-f fab-b pr-3"></i>
                    <i class="fab fa-twitter fab-b pr-3"></i>
                    <i class="fab fa-google fab-b pr-3"></i>
                    <i class="fab fa-instagram fab-b pr-3"></i>
                    <i class="fab fa-youtube fab-b"></i>
                </div>

            </div> 
        </div>
    </div>
 
<!--end header-caption-->   

<!--start logo-->
    <section class="logo py-5">
        <div class="container">
            <div class="row">

                <div class="col-lg-4 col-md-12">
                    <div>
                        <img src="assets/images/logo.png" class="img-fluid" alt="logo">
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="media">
                        <i class="fas fa-pencil-alt p-2 mr-3  "></i>
                        <div class="media-body">
                          <h5 class="mt-0">0 (800) 123 4567</h5>
                         <span>pharmacom@example.com</span> 
                        </div>
                      </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="media">
                        <i class="fas fa-pencil-alt p-2 mr-3 "></i>
                        <div class="media-body">
                          <h5 class="mt-0">0 (800) 123 4567</h5>
                         <span>Kansas City, KS 66223</span> 
                        </div>
                      </div>
                </div>

    
            </div>
        </div>
        
    </section>

<!--end logo-->

<!--start navbar-->
    <nav class="navbar navbar-expand-lg navbar-dark  bg-light border-none">
        
        <button class="navbar-toggler"  type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon border-none"></span>
        </button>
      
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <a class="nav-link only" routerLink="home">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="pipeline">Pipeline</a>

            </li>
            
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#"  id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Pages
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" routerLink="about">About</a>
                <a class="dropdown-item" routerLink="departments">Departments</a>
                <a class="dropdown-item" routerLink="shop">Shop</a>
                <a class="dropdown-item" routerLink="team">Team</a>
                <a class="dropdown-item" routerLink="faq">FAq</a>
                <a class="dropdown-item" routerLink="404">404</a>
                
              </div>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="blog">Blog</a>
              </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Gallery
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" routerLink="carousel">Gallery Carousel</a>
                  <a class="dropdown-item" routerLink="fullwidth">Gallery Full width</a>
                 
                </div>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="contact">Contacts</a>
              </li>
            
          </ul>
         <ul class="navbar-nav ml-auto pr-4 ">
            <li>
                <a class="nav-link"><i class="fas fa-search"></i></a>
            </li>
            <li>
                <a class="nav-link" ><i class="fas fa-user"></i></a>
            </li>
            <li>
                <a class="nav-link"><i class="fas fa-shopping-basket"></i></a>
            </li>
              

         </ul>
        </div>
      </nav>
      
<!--end navbar-->

</header>

<!--end header-->

